import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes tardaba 40 minutos en armar el plan de cada paciente nuevo. Con el NutriPro Kit lo tengo listo en 10. Un cambio total en mi consulta.',
  name: 'Valentina R.',
  title: 'Lic. en Nutrición',
  city: 'Córdoba',
  initials: 'VR'
}, {
  quote: 'Recién me recibí y no sabía cómo organizar nada. Este kit me dio la estructura profesional que necesitaba desde el primer día.',
  name: 'Martín G.',
  title: 'Nutricionista',
  city: 'Rosario',
  initials: 'MG'
}, {
  quote: 'Los gráficos de progreso que le muestro a cada paciente generaron un cambio enorme en la adherencia al tratamiento. Lo recomiendo.',
  name: 'Florencia M.',
  title: 'Lic. en Nutrición',
  city: 'CABA',
  initials: 'FM'
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-272">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-273">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-274">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gray-50 rounded-2xl p-8 relative border border-gray-100 flex flex-col" data-id="element-275">
              <Quote className="absolute top-6 right-6 text-gray-200" size={40} data-id="element-276" />

              <div className="flex text-yellow-400 mb-4" data-id="element-277">
                {[...Array(5)].map((_, starIdx) => <Star key={starIdx} size={18} fill="currentColor" data-id="element-278" />)}
              </div>

              <p className="text-gray-700 italic mb-8 relative z-10 leading-relaxed flex-grow" data-id="element-279">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-280">
                <div className="w-12 h-12 rounded-full bg-nutri-medium text-white flex items-center justify-center font-bold text-lg" data-id="element-281">
                  {t.initials}
                </div>
                <div data-id="element-282">
                  <h4 className="font-bold text-gray-900" data-id="element-283">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-284">
                    {t.title}, {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}